exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td[data-v-104ba0e1]:first-child{border-left:none}td.current-month[data-v-104ba0e1]{border-left:3px solid red;border-right:3px solid red}", ""]);

// exports
